import { Link } from "react-router-dom";
import type { Category } from "@/types";
import SectionHeading from "@/components/base/SectionHeading";

interface CategoryWithCount {
  category: Category;
  count: number;
}

interface CategoryGridProps {
  items: CategoryWithCount[];
}

export default function CategoryGrid({ items }: CategoryGridProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <SectionHeading
        eyebrow="Featured Collections"
        title="赛事专题推荐"
        desc="按竞技项目浏览赛事专题，快速定位你关注的比赛类型。"
        action={
          <Link
            to="/events"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            全部专题 <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map(({ category, count }) => (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group relative rounded-lg overflow-hidden h-56 border border-background-200"
          >
            <img
              src={category.cover}
              alt={category.name}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/40 to-transparent" />
            <div className="absolute inset-0 p-5 flex flex-col justify-end">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-8 h-8 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${category.icon} text-base`} />
                </span>
                <h3 className="font-heading text-lg text-background-50">{category.name}</h3>
              </div>
              <p className="text-xs text-background-200 line-clamp-2">{category.desc}</p>
              <div className="mt-3 flex items-center gap-2 flex-wrap">
                {category.subs.slice(0, 3).map((s) => (
                  <span key={s} className="px-2 py-0.5 rounded-full bg-background-50/20 text-background-50 text-[10px] backdrop-blur">
                    {s}
                  </span>
                ))}
                <span className="ml-auto text-[11px] text-background-100 font-label">{count} 场赛事</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}